import { goTo } from '@avalara/bat-apps-shared/client/helpers/window';
import type { Result } from '@avalara/types/index';

import conf from '../../conf';
import { setCamundaTaskId, setQuestionConfig } from '../../store/prequal-questionnaire';
import analytics from '../analytics';
import fetch from '../fetch';
import { getSystemErrorMessaging } from './error';

import type { Dispatch, ThunkAction } from '@avalara/types/actions';
import type { State } from '@avalara/types/reducer-states';
import type {
  GetTaskResponse,
  PrequalQuestionnaire,
  QuestionnaireResults,
} from '../../../../types/prequal-questionnaire';

export const fetchQuestionnaireConfig = () => async (dispatch: Dispatch) => {
  const result: Result<PrequalQuestionnaire> = await fetch(dispatch)(
    `${conf.API_URL}/api/question/config${window.location.search}`,
  );

  if (!result.ok) {
    dispatch(getSystemErrorMessaging({ errorCode: 'prequalQuestionnaireError' }));
  } else {
    dispatch(setQuestionConfig(result.value));
  }
};

export const exitQuestionnaire =
  (url: string, offRampId?: string): ThunkAction =>
  async (dispatch: Dispatch, getState: () => State) => {
    const {
      questionnaire: { config, selectedAnswers, camundaTaskId },
    } = getState();

    const results: QuestionnaireResults = {
      questionnaireName: config?.name || 'unknown',
      selectedAnswers,
      offRampId,
    };

    analytics.track('QUESTIONNAIRE_RESULTS', { results });

    await fetch(dispatch)(`${conf.API_URL}/api/koala`, { method: 'POST', body: JSON.stringify(results) });

    await fetch(dispatch)(`${conf.API_URL}/api/camunda/complete-task`, {
      method: 'POST',
      body: JSON.stringify({ results, taskId: camundaTaskId }),
    });

    goTo(url);
  };

export const startQuestionnaireCamundaProcess = () => async (dispatch: Dispatch, getState: () => State) => {
  const {
    questionnaire: { config },
  } = getState();
  const questionnaireName = config?.name || 'unknown';

  const task = await fetch(dispatch)<GetTaskResponse>(`${conf.API_URL}/api/camunda/start-process`, {
    method: 'POST',
    body: JSON.stringify({ questionnaireName }),
  });

  if (!task.ok) return;
  const taskId = task.value[0].id;
  dispatch(setCamundaTaskId(taskId));
};
